import { VoicemailOverviewDto } from "@/repository/models";
import {
	getVoicemailOverview,
	voicemailOverviewKey,
} from "@/repository/queryFns/voicemails";
import { useQuery } from "@tanstack/react-query";
import { InteractionWorkspaceProps } from "./types";
import { VoicemailContent } from "@/components/molecules/voicemail/VoicemailContent";

export const VoicemailHistoryInteractionContent = (
	props: InteractionWorkspaceProps
) => {

	const { historyItem } = props;

	const { data: voicemailOverview } = useQuery<VoicemailOverviewDto>(
		{
			queryKey: [voicemailOverviewKey, historyItem.id],
			queryFn: () => getVoicemailOverview(historyItem.id),
		}
	);

	return (
		<>
			{voicemailOverview && (
				<VoicemailContent voicemailOverview={voicemailOverview} />
			)}
		</>
	);
};
